import { Link } from 'react-router-dom';
import { CURRENCY } from '@voladeum/client';
import { Strategy } from 'client/voladeum/strategies/types';
import { useGridColumnContext } from 'framework/Grid/context/GridColumnContext';
import { useGridRowContext } from 'framework/Grid/context/GridRowContext';

import { CRYPTO_PATH } from '../../constants';

import cn from './Cell.module.scss';

const { PUBLIC_URL } = process.env;

export const GridPairStrategyCell = () => {
  const { row } = useGridRowContext<Strategy>();
  const { column } = useGridColumnContext();

  return (
    <Link
      className={cn.cell}
      to={`/application/strategies/${row.strategy_id}`}
      style={{ justifyContent: column.text_align }}
    >
      <img
        src={`${PUBLIC_URL}/cryptocurrencies/${CRYPTO_PATH[row.base_currency_id as CURRENCY]}.svg`}
        alt={row.base_currency_name}
      />
      <div className={cn.stacked}>
        <span>
          {row.pair_name}: {row.strategy_name}
        </span>
        <span className={cn.small}>{row.base_currency_name}</span>
      </div>
    </Link>
  );
};
